import { getTopicHubByPath } from '../data/topic-hubs';
import { DOMAIN, canonicalPath, getSeoRouteByPath } from './seo-routes';
import type { PageRouteType } from './route-loader';

export interface ResolvedRoute {
  type: PageRouteType;
  href: string;
  id?: string;
  slug?: string;
  search?: string;
}

const staticPageTypes: Record<string, PageRouteType> = {
  '/': 'home', '/airports': 'airports', '/blog': 'blog',
  '/flight-calculator': 'flight-calculator', '/currency-converter': 'currency-converter',
  '/checklist': 'checklist', '/game': 'game', '/tools': 'tools',
  '/passenger-rights': 'passenger-rights', '/about': 'about', '/contact': 'contact',
  '/privacy': 'privacy', '/terms': 'terms', '/advertising': 'advertising',
  '/editorial-policy': 'editorial-policy', '/quiz': 'quiz'
};

/** Resolve only published pages; an arbitrary airport/blog slug is a 404. */
export function resolveRoute(href: string): ResolvedRoute {
  const url = new URL(href, DOMAIN);
  const seo = url.origin === DOMAIN ? getSeoRouteByPath(url.pathname) : undefined;
  if (!seo) return { type: 'not-found', href: url.pathname + url.search + url.hash };
  const route: ResolvedRoute = {
    type: staticPageTypes[seo.path] || 'not-found',
    href: canonicalPath(seo.path) + url.search + url.hash,
    search: url.searchParams.get('search') || undefined
  };
  if (seo.kind === 'airport') return { ...route, type: 'airport-detail', id: seo.path.split('/')[2] };
  if (seo.kind === 'article') return { ...route, type: 'blog-post', slug: seo.path.split('/')[2] };
  const hub = getTopicHubByPath(seo.path);
  return hub ? { ...route, type: 'topic-hub', slug: hub.slug } : route;
}

export function canonicalInternalHref(href: string) {
  if (!href.startsWith('/') || href.startsWith('//')) return href;
  return resolveRoute(href).href;
}
